import { useNavigate } from "react-router-dom";
import { Column } from "../../../../../core/components/Column";
import { CustomButton } from "../../../../../core/components/CustomButton";
import { TextComponent } from "../../../../../core/components/TextComponent";
import { ArrowDown2 } from "../../../../../core/icons/ArrowDown";

export const InstantMessageInfoScreen = () => {
  const navigate = useNavigate();

  return (
    <Column className="bg-white p-6 md:p-8 gap-4 md:gap-5 max-md:overflow-y-auto">
      <button
        type="button"
        onClick={() => navigate("/profile")}
        className="w-10 aspect-square flex items-center justify-center text-primary transform rotate-90 rounded-full hover:bg-grayDefault"
        aria-label="Back to profile"
      >
        <ArrowDown2 />
      </button>

      <TextComponent variant="h2" className="text-primary font-bold">
		INSTANT MESSAGES: A PAID MEMBER BENEFIT
      </TextComponent>

      <TextComponent variant="h4" className="font-semibold">
        Instant Messages let you contact someone before you match.
      </TextComponent>

      <TextComponent variant="h5">
        This type of messaging feature appears under a person&apos;s profile while you&apos;re browsing.
      </TextComponent>

      <TextComponent variant="h5" className="font-semibold">
		Paid members receive 5 included Instant Messages in every paid subscription month.
      </TextComponent>

	  <TextComponent variant="h5">
		The included allowance refreshes each paid month and unused included messages do not roll over. Any separately purchased credits remain available.
	  </TextComponent>

      <TextComponent variant="h3" className="text-primary font-bold">
        How it works
      </TextComponent>

      <Column className="gap-2">
        <ul className="list-disc pl-6 space-y-2 text-sm md:text-base">
          <li>You can send one introduction message per person.</li>
          <li>If they reply, a normal chat opens and you can keep messaging each other.</li>
          <li>If they don&apos;t reply, you can&apos;t send another Instant Message to that same person.</li>
        </ul>
      </Column>

	  <TextComponent variant="h5">
		Browsing, liking, matching and chatting with your matches remain free.
	  </TextComponent>

      <div className="pt-2">
		<CustomButton onClick={() => navigate("/subscription")} className="md:w-80">
		  View Subscription Plans
        </CustomButton>
      </div>
    </Column>
  );
};
